import { Component, EventEmitter, Output } from '@angular/core';
import { ImageSource } from '@app/features/app-content/services/image-resizing.service';
import { UiModule } from '@app/ui';
import { SelectedImage } from '@app/ui/components/image-upload/image-upload.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rk-splashscreen-upload',
  templateUrl: './splashscreen-upload.component.html',
  styleUrl: './splashscreen-upload.component.scss',
  imports: [UiModule, TranslateModule, FontAwesomeModule],
})
export class SplashscreenUploadComponent {
  @Output() readonly rawImageSelected = new EventEmitter<{
    source: ImageSource;
    selectedImage: SelectedImage;
  }>();

  onRawImageSelected(selectedImage: SelectedImage) {
    this.rawImageSelected.emit({ source: 'rawSplashscreen', selectedImage });
  }
}
